import { PrivateScenariosPage } from "@/shared/pages/PrivateScenariosPage";
import { registerWidget } from "@/shared/dashboard/widgets/registry";

export {
  CONSUMER_EXERCISE_COPY,
  CONSUMER_DASHBOARD_EMPTY_COPY,
} from "@/shared/pages/PrivateScenariosPage";
export const ConsumerPrivateExerciseWorkspace = PrivateScenariosPage;
export const ConsumerDashboardEmptyWidget = PrivateScenariosPage;

registerWidget({
  id: "consumerDashboardEmpty",
  component: PrivateScenariosPage,
  supportedSlots: new Set(["hero"]),
  displayName: "Private scenarios",
});
